import React from 'react';
import AssetTeamNavBar from '../../../../layouts/asset-team/AssetTeamNavBar';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import CustomersTrackerBody from '../../../shared/customers/tracker/CustomersTrackerBody';

const AssetTeamCustomersTracker = () => {
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AssetTeamNavBar currentPage="Daily Subscription Tracker" position={firstName} />
        <CustomersTrackerBody />
      </main>
    </div>
  );
};

export default AssetTeamCustomersTracker;
